<template>
    <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane v-if="userSubRole ===3" label="User" name="first">
            <Users></Users>
        </el-tab-pane>

        <el-tab-pane v-if="userSubRole ===3" label="Admin" name="second">
            <administrator></administrator>
        </el-tab-pane>

        <el-tab-pane v-if="userSubRole ===3" label="Helper Management" name="helper">
            <helper-admin></helper-admin>
        </el-tab-pane>

        <el-tab-pane label="Estate MA" name="Ma">
            <MaAccountManage></MaAccountManage>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
    import Users from "@/view/eazable/users/Users";
    import Administrator from "@/view/eazable/users/Administrator";
    import HelperAdmin from "@/view/eazable/users/HelperAdmin";
    import MaAccountManage from "@/view/property/account/MaAccountManage";
    import {mapGetters} from "vuex";

    export default {
        name: "UserList",
        components: {MaAccountManage, HelperAdmin, Administrator, Users},
        computed: mapGetters({
            userSubRole: 'getSubRole',

        }),
        data() {
            return {
                activeName: 'first'
            }
        }
    }
</script>

<style scoped>

</style>
